import React from 'react';
import { useSelector } from 'react-redux';
import { ChatHistory } from '@axtria/hqi-genai';
import '@axtria/hqi-genai/lib/hqi-genai.css';

const baseURL = process.env.REACT_APP_HQI_BASE_URL
const middlewareURL = process.env.REACT_APP_HQI_MIDDLEWARE_URL
const UMUrl = process.env.REACT_API_URL

interface ChatHistoryComponentProps {
  showChatHistory: boolean;
  chatHistoryRef: React.RefObject<HTMLDivElement>;
  userInfo: any;
  getTeamName: () => string;
  handleNewChat: () => void;
  handleChatSelect: (_chat: any) => void;
  handleDelete: (_id: string) => void;
  handleRename: (_id: string, _newTitle?: string) => void;
}

const ChatHistoryComponent: React.FC<ChatHistoryComponentProps> = ({
  showChatHistory,
  chatHistoryRef,
  userInfo,
  getTeamName,
  handleNewChat,
  handleChatSelect,
  handleDelete,
  handleRename,
}) => {
  const { activeKnowledgeId } = useSelector((state: any) => ({
    activeKnowledgeId: state.loginResource.activeKnowledgeId,
  }));

  if (!showChatHistory) return null;

  return (
    <div className="home-screen-chat-history" ref={chatHistoryRef}>
      <ChatHistory 
        DOMAIN={baseURL}
        DOMAIN_MIDDLEWARE={middlewareURL}
        DOMAIN_UM={UMUrl}
        TEAM={getTeamName()}
        PROJECT_ID={userInfo?.preferredProject}
        KNOWLEDGE_ID={activeKnowledgeId}
        onNewChat={handleNewChat}
        onChatSelect={handleChatSelect}
        onDelete={handleDelete}
        onRename={handleRename}
      />
    </div>
  );
};

export default ChatHistoryComponent;
